import { z } from '@hono/zod-openapi'

export const zQrcodeEligibilityResponse = z.object({
    eligible: z.literal(true),
    benefitTitle: z.string(),
    clientName: z.string(),
    employeeName: z.string(),
    employeeEmail: z.string(),
    employeePhone: z.string().nullable(),
    expiresAt: z.string(),
})

export const zSendQrcodeVerificationCodeRequest = z.object({
    channel: z.enum(['email', 'phone']).default('email'),
})

export const zSendQrcodeVerificationCodeResponse = z.object({
    message: z.string(),
    channel: z.string(),
    recipient: z.string(),
    expiresInSeconds: z.number(),
})

export const zRedeemQrcodeRequest = z.object({
    verificationCode: z.string().min(4).max(10),
})

export const zRedeemQrcodeResponse = z.object({
    message: z.string(),
    redeemedAt: z.string(),
    benefitTitle: z.string().optional(),
    clientName: z.string().optional(),
    employeeName: z.string().optional(),
})

export type QrcodeRedeemResponse = z.infer<typeof zRedeemQrcodeResponse>
export type RedeemQrcodeRequest = z.infer<typeof zRedeemQrcodeRequest>
export type QrcodeEligibilityResponse = z.infer<
    typeof zQrcodeEligibilityResponse
>
export type SendQrcodeVerificationCodeRequest = z.infer<
    typeof zSendQrcodeVerificationCodeRequest
>
export type SendQrcodeVerificationCodeResponse = z.infer<
    typeof zSendQrcodeVerificationCodeResponse
>
